import { idbAttributeTypes } from './IDB/helpers';
import { retainerAttributeTypes } from './Retainer/helpers';

const attributeTypes = {
  ...idbAttributeTypes,
  ...retainerAttributeTypes
};

export function encodeFormikValues(values) {
  return Object.fromEntries(
    Object.entries(values).map(([attr, value]) => {
      let encodeValue = value;
      if (attributeTypes[attr]) {
        if (attributeTypes[attr] === Boolean) {
          encodeValue = Number(value);
        }
        encodeValue = value === null ? null : String(encodeValue);
      }
      return [attr, encodeValue];
    })
  );
}

export function decodeFormikValues(encodedValues) {
  return Object.fromEntries(
    Object.entries(encodedValues).map(([attr, value]) => {
      let decodedValue = value;
      if (decodedValue !== null && attributeTypes[attr]) {
        if (decodedValue === '' && attributeTypes[attr] === Number) {
          decodedValue = null;
        } else {
          decodedValue = Number(decodedValue);
        }

        if (attributeTypes[attr] === Boolean) {
          decodedValue = Boolean(decodedValue);
        }
      }
      return [attr, decodedValue];
    })
  );
}
